import { BdsModal, BdsModalAction } from 'blip-ds/dist/blip-ds-react/components';
import React, { useEffect, useRef } from 'react';
import { ModalProps } from 'typings';

export const Modal: React.FC<ModalProps> = ({
    open,
    children,
    footer,
    size = 'dynamic',
    closeButton = false,
    outzoneClose = false,
    enterClose = false,
    onClose,
}) => {
    const blipModalRef = useRef<HTMLBdsModalElement>(null);

    useEffect(() => {
        const { current } = blipModalRef;
        if (!current || !onClose) return;
        current.addEventListener('bdsModalChanged', onClose);
        return () => {
            current.removeEventListener('bdsModalChanged', onClose);
        };
    }, [onClose]);

    return (
        <BdsModal
            size={size}
            open={open}
            ref={blipModalRef}
            close-button={closeButton}
            outzoneClose={outzoneClose}
            enterClose={enterClose}
        >
            {children}
            {footer && <BdsModalAction>{footer}</BdsModalAction>}
        </BdsModal>
    );
};
